import React from 'react';
import data from '../data.json';
import '../style.css';

function Home() {
  return (
    <>
      {/* Carousel */}
      <div id="carouselExampleFade" className="carousel slide carousel-fade mb-5" data-bs-ride="carousel">
        <div className="carousel-inner">
          {data.carousel.map((img, i) => (
            <div className={`carousel-item ${i === 0 ? 'active' : ''}`} key={i}>
              <img src={img} className="d-block w-100 rounded-4 shadow-sm" alt={`slide-${i}`} />
            </div>
          ))}
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
        </button>
      </div>

      {/* About Section */}
      <div className="container">
        <div className="row align-items-center my-5" data-aos="fade-up">
          <div className="col-md-6">
            <h2 className="fw-bold">{data.about.title}</h2>
            <p className="lead">{data.about.description}</p>
          </div>
          <div className="col-md-6">
            <img src={data.about.image} className="img-fluid rounded-4 shadow" alt="About" />
          </div>
        </div>

        {/* Facilities Section */}
        <h2 className="text-center mt-5 mb-4 fw-bold" data-aos="zoom-in">Our Graphics</h2>
        <div className="row">
          {data.facilities.map((f, index) => (
            <div className="col-md-4 mb-4" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="card p-3 h-100 shadow-sm rounded-4">
                <img src={f.image} className="card-img-top rounded-3" alt={f.title} />
                <div className="card-body">
                  <h5 className="card-title fw-semibold">{f.icon} {f.title}</h5>
                  <p className="card-text">{f.details}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Home;
